export class DeemphasizedUtil {
  public static classes(): string[] {
    const classes: string[] = [
      'opacity-50',
      'hover:opacity-100',
      'transition-[opacity]',
      'duration-500',
    ];
    return classes;
  }
}
